<template>
    <div class="suggestions">
      <p>{{$t('common.tag_input.cleaned_up_text')}}:</p>
      <el-tooltip class="item" effect="dark" content="Click to replace the item." placement="top-start">
        <p @click="$emit('using_cleanup_text', props)" class="replace-item">{{ props.tag.clean_text }}</p>
      </el-tooltip>
    </div>
  </template>
  
  <script>
    import { mapGetters } from 'vuex';
  
    export default {
      props: {
          props: {
              type: Object
          },
      },
      computed: {
      },
    }
  </script>
  
  <style lang="scss" scoped>
      .replace-item {
          color: #2DA771;
          cursor: pointer;
          font-weight: 600;
      }
  </style>
  